import React from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import { SharedLinkHeader as Component } from 'components/shared-link-header';

const SharedLinkHeader = (props) => (
  <CWOConfigProvider>
    <Component {...props} />
  </CWOConfigProvider>
);

export default SharedLinkHeader;
